import React, { useState } from "react";
import { useStateContext } from "../../contexts/ContextProvider";

import { days, leaveDays } from "../../data";

const EditLeaveType = ({ editLeaveType }) => {
  const { years } = useStateContext();

  const [rows, setRows] = useState([
    {
      exp: "0-3 Years",
      yearly: "10",
      quarterly: "5",
      monthly: "2",
    },
  ]);

  const [checked, setChecked] = useState({
    isGeneral: false,
    yearly: false,
    quarterly: false,
    monthly: false,
    expCat: false,
  });

  const [details, setDetails] = useState({
    leaveName: "",
    isGeneral: "",
    year: "",
    yearStartDate: "",
    yearEndDate: "",
    leaveCount: [
      {
        exp: "",
        yearly: "10",
        quarterly: "5",
        monthly: "2",
      },
    ],
  });

  // console.log(years);

  const handleChecked = (e, type) => {
    setChecked({ ...checked, [type]: e.target.checked });
  };

  const addNewRow = (e) => {
    setRows([
      ...rows,
      {
        exp: "",
        yearly: "",
        quarterly: "",
        monthly: "",
      },
    ]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetails({ ...details, [name]: value });
  };

  const handleSelectLeaveDuration = (e, type) => {
    // console.log(e.target.value, type);

    let leaveCounts = [];

    if (type === "yearly") {
      leaveCounts = [
        {
          exp: "",
          yearly: e.target.value,
          quarterly: details.leaveCount[0].quarterly,
          monthly: details.leaveCount[0].monthly,
        },
      ];
    } else if (type === "quarterly") {
      leaveCounts = [
        {
          exp: "",
          yearly: details.leaveCount[0].yearly,
          quarterly: e.target.value,
          monthly: details.leaveCount[0].monthly,
        },
      ];
    } else if (type === "monthly") {
      leaveCounts = [
        {
          exp: "",
          yearly: details.leaveCount[0].yearly,
          quarterly: details.leaveCount[0].quarterly,
          monthly: e.target.value,
        },
      ];
    }

    setDetails({ ...details, leaveCount: leaveCounts });
  };

  // console.log("details", details);

  // console.log("rows", rows);

  return (
    <>
      <div
        className={`${
          editLeaveType
            ? "add-event feedback policy visible"
            : "add-event feedback policy hidden"
        }`}
      >
        <div className="flex mb-5">
          <div className="left-flex mb-4">
            <span>Add Leave </span>
          </div>
          <div className="event-form scroll">
            <div className="mb-3">
              <label htmlFor="" className="form-label">
                Add Leave Name
              </label>
              <input
                type="text"
                className="form-control"
                name="leaveName"
                value={details.leaveName}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3 leave-cat">
              <div className="flex">
                <label className="radio-container">
                  <input
                    type="checkbox"
                    checked={checked.isGeneral}
                    onChange={(e) => {
                      handleChecked(e, "isGeneral");
                    }}
                  />
                  <span className="checkmark"></span>
                  <span className="text">General category</span>
                </label>
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="" className="form-label">
                Select Year
              </label>
              <select
                name="year"
                value={details.year}
                onChange={handleInputChange}
              >
                {Array.isArray(years)
                  ? years.map((item) => {
                      return <option key={item} value={item}>{item}</option>;
                    })
                  : null}
              </select>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label htmlFor="" className="form-label">
                    Year Start date
                  </label>
                  <select
                    name="yearStartDate"
                    value={details.yearStartDate}
                    onChange={handleInputChange}
                  >
                    {Array.isArray(days)
                      ? days.map((item) => {
                          return (
                            <option key={item.value} value={item.value}>{item.label}</option>
                          );
                        })
                      : null}
                  </select>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label htmlFor="" className="form-label">
                    Year end date
                  </label>
                  <select
                    name="yearEndDate"
                    value={details.yearEndDate}
                    onChange={handleInputChange}
                  >
                    {Array.isArray(days)
                      ? days.map((item) => {
                          return (
                            <option key={item.value} value={item.value}>{item.label}</option>
                          );
                        })
                      : null}
                  </select>
                </div>
              </div>
            </div>
            {!checked.isGeneral && (
              <>
                <div className="mb-3">
                  <label htmlFor="" className="form-label">
                    Applicable For
                  </label>
                  <div className="d-flex gap-2">
                    <label className="checkbox-container">
                      <input
                        type="checkbox"
                        checked={checked.yearly}
                        onChange={(e) => {
                          handleChecked(e, "yearly");
                        }}
                      />
                      <span className="checkmark"></span>
                      <span className="text">Yearly</span>
                    </label>
                    <label className="checkbox-container">
                      <input
                        type="checkbox"
                        checked={checked.quarterly}
                        onChange={(e) => {
                          handleChecked(e, "quarterly");
                        }}
                      />
                      <span className="checkmark"></span>
                      <span className="text">Quarterly</span>
                    </label>
                    <label className="checkbox-container">
                      <input
                        type="checkbox"
                        checked={checked.monthly}
                        onChange={(e) => {
                          handleChecked(e, "monthly");
                        }}
                      />
                      <span className="checkmark"></span>
                      <span className="text">Monthly</span>
                    </label>
                    <label className="checkbox-container">
                      <input
                        type="checkbox"
                        checked={checked.expCat}
                        onChange={(e) => {
                          handleChecked(e, "expCat");
                        }}
                      />
                      <span className="checkmark"></span>
                      <span className="text">Add experience category </span>
                    </label>
                  </div>
                </div>
                <div className="mb-3">
                  {checked.yearly && (
                    <>
                      {checked.expCat ? (
                        <>
                          <div className="mb-3">
                            <label htmlFor="" className="form-label">
                              Enter Yearly Leave Duration
                            </label>

                            {rows.map((row, index) => (
                              <div className="row mb-3" key={index}>
                                <div className="col-lg-6">
                                  <input
                                    type="text"
                                    placeholder="Enter Experience"
                                    value={row.exp}
                                    onChange={(e) => {
                                      const newRows = [...rows];
                                      newRows[index].exp =
                                        e.target.value;
                                      setRows(newRows);
                                    }}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <select
                                    value={row.yearly}
                                    onChange={(e) => {
                                      const newRows = [...rows];
                                      newRows[index].yearly = e.target.value;
                                      setRows(newRows);
                                    }}
                                  >
                                    {Array.isArray(leaveDays)
                                      ? leaveDays.map((item) => (
                                          <option
                                            key={item.value}
                                            value={item.value}
                                          >
                                            {item.label}
                                          </option>
                                        ))
                                      : null}
                                  </select>
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      ) : (
                        <div className="mb-3">
                          <label htmlFor="" className="form-label">
                            Enter Yearly Leave Duration
                          </label>
                          <select
                            name="yearEndDate"
                            value={details.leaveCount[0].yearly}
                            onChange={(e) => {
                              handleSelectLeaveDuration(e, "yearly");
                            }}
                          >
                            {Array.isArray(leaveDays)
                              ? leaveDays.map((item) => {
                                  return (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  );
                                })
                              : null}
                          </select>
                        </div>
                      )}
                    </>
                  )}
                  {checked.expCat && (
                    <div className="addRow">
                      <button onClick={addNewRow}>
                        <div className="circle">
                          <svg
                            width="46"
                            height="46"
                            viewBox="0 0 46 46"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              opacity="0.5"
                              d="M42.1654 23.0007C42.1654 33.586 33.5841 42.1673 22.9987 42.1673C12.4132 42.1673 3.83203 33.586 3.83203 23.0007C3.83203 12.4152 12.4132 3.83398 22.9987 3.83398C33.5841 3.83398 42.1654 12.4152 42.1654 23.0007Z"
                              fill="#1C274C"
                            ></path>
                            <path
                              d="M24.4375 17.25C24.4375 16.4561 23.7939 15.8125 23 15.8125C22.2061 15.8125 21.5625 16.4561 21.5625 17.25V21.5625H17.25C16.4561 21.5625 15.8125 22.2061 15.8125 23C15.8125 23.7939 16.4561 24.4375 17.25 24.4375H21.5625V28.75C21.5625 29.5439 22.2061 30.1875 23 30.1875C23.7939 30.1875 24.4375 29.5439 24.4375 28.75V24.4375H28.75C29.5439 24.4375 30.1875 23.7939 30.1875 23C30.1875 22.2061 29.5439 21.5625 28.75 21.5625H24.4375V17.25Z"
                              fill="white"
                            ></path>
                          </svg>
                        </div>
                        <span>Add</span>
                      </button>
                    </div>
                  )}

                  {checked.quarterly && (
                    <>
                      {checked.expCat ? (
                        <div className="mb-3">
                          <label htmlFor="" className="form-label">
                            Enter Quarterly Leave Duration
                          </label>
                          {rows.map((row, index) => (
                            <div className="row mb-3" key={index}>
                              <div className="col-lg-6">
                                <input
                                  type="text"
                                  placeholder="Enter Experience"
                                  value={row.exp}
                                  onChange={(e) => {
                                    const newRows = [...rows];
                                    newRows[index].exp = e.target.value;
                                  
                                    setRows(newRows);
                                  }}
                                />
                              </div>
                              <div className="col-lg-6">
                                <select
                                  value={row.quarterly}
                                  onChange={(e) => {
                                    const newRows = [...rows];
                                    newRows[index].quarterly = e.target.value;
                                    setRows(newRows);
                                  }}
                                >
                                  {Array.isArray(leaveDays)
                                    ? leaveDays.map((item) => (
                                        <option
                                          key={item.value}
                                          value={item.value}
                                        >
                                          {item.label}
                                        </option>
                                      ))
                                    : null}
                                </select>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="mb-3">
                          <label htmlFor="" className="form-label">
                            Enter Quarterly Leave Duration
                          </label>
                          <select
                            value={details.leaveCount[0].quarterly}
                            onChange={(e) => {
                              handleSelectLeaveDuration(e, "quarterly");
                            }}
                          >
                            {Array.isArray(leaveDays)
                              ? leaveDays.map((item) => {
                                  return (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  );
                                })
                              : null}
                          </select>
                        </div>
                      )}
                    </>
                  )}
                  {checked.monthly && (
                    <>
                      {checked.expCat ? (
                        <div className="mb-3">
                          <label htmlFor="" className="form-label">
                            Enter Monthly Leave Duration
                          </label>
                          {rows.map((row, index) => (
                            <div className="row mb-3" key={index}>
                              <div className="col-lg-6">
                                <input
                                  type="text"
                                  placeholder="Enter Experience"
                                  value={row.exp}
                                  onChange={(e) => {
                                    const newRows = [...rows];
                                    newRows[index].exp = e.target.value;
                                    setRows(newRows);
                                  }}
                                />
                              </div>
                              <div className="col-lg-6">
                                <select
                                  value={row.monthly}
                                  onChange={(e) => {
                                    const newRows = [...rows];
                                    newRows[index].monthly = e.target.value;
                                    setRows(newRows);
                                  }}
                                >
                                  {Array.isArray(leaveDays)
                                    ? leaveDays.map((item) => (
                                        <option
                                          key={item.value}
                                          value={item.value}
                                        >
                                          {item.label}
                                        </option>
                                      ))
                                    : null}
                                </select>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="mb-3">
                          <label htmlFor="" className="form-label">
                            Enter Monthly Leave Duration
                          </label>
                          <select
                            value={details.leaveCount[0].monthly}
                            onChange={(e) => {
                              handleSelectLeaveDuration(e, "monthly");
                            }}
                          >
                            {Array.isArray(leaveDays)
                              ? leaveDays.map((item) => {
                                  return (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  );
                                })
                              : null}
                          </select>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>

          <div className="sort-action">
            <button className="btn btn-reset">Reset</button>
            <button className="btn btn-apply">Add</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditLeaveType;
